import { useHistory } from 'react-router-dom'
import './style.css'

export default function Navbar() {

    const history = useHistory()
    function handleLogout(e){
        e.preventDefault()
        localStorage.clear()
        history.push('/login')
    }


    return (
        <header className="navbar">
            <div className=''>
                AI HUB
            </div>
            <div>
                <button className='btn' onClick={(e) => handleLogout(e)}>Logout</button>
            </div>
        </header>

    )
}